import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=50d174fa&"
import script from "./dashboards.js?vue&type=script&lang=js&"
export * from "./dashboards.js?vue&type=script&lang=js&"
import style0 from "./dashboards.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports